import { Stack } from '@mui/material';
import React from 'react';

import { AgGridTableCore } from '@/shared/components/ui/data-table/components/ag-grid-table-core/ag-grid-table-core';
import { ColumnStateSync } from '@/shared/components/ui/data-table/components/column-state-sync/column-state-sync';
import { useDataTable } from '@/shared/components/ui/data-table/context/data-table-context';
import { DataTablePaper } from '@/shared/components/ui/data-table/data-table.styled';
import { useEmptyStateRenderer } from '@/shared/components/ui/data-table/hooks/use-empty-state-renderer/use-empty-state-renderer';
import { FilterDefaultsProvider } from '@/shared/components/ui/data-table/hooks/use-filter-params/filter-defaults-context';
import { InnerDataTableHeader } from '@/shared/components/ui/data-table/variant/inner-data-table/components/inner-data-table-header/inner-data-table-header';
import { TInnerDataTableProps } from '@/shared/components/ui/data-table/variant/inner-data-table/inner-data-table.types';
import { Pagination } from '@/shared/components/ui/pagination/pagination';

export const InnerDataTable = <T,>({
  header,
  batchActions,
  customEmptyMessage,
  onItemClick,
}: TInnerDataTableProps<T>) => {
  const { data } = useDataTable<T>();
  const { refetch } = data;

  const renderEmptyState = useEmptyStateRenderer({
    customEmptyMessage,
    emptyMessageVariant: 'p8',
    emptyMessageColor: 'textSecondary',
  });

  return (
    <Stack position="relative" width="100%" height="100%" gap="1.5rem">
      <DataTablePaper $isInnerPage>
        <FilterDefaultsProvider>
          {(header || batchActions || !!refetch) && (
            <InnerDataTableHeader<T> {...header} batchActions={batchActions} />
          )}
          <AgGridTableCore<T>
            noRowsOverlayComponent={renderEmptyState}
            onItemClick={onItemClick}
            disableSelection={!batchActions}
          />
          <Pagination />
          <ColumnStateSync />
        </FilterDefaultsProvider>
      </DataTablePaper>
    </Stack>
  );
};
